module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_name"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'CurrencyTypeList'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4a55f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/currencytype/Form.vue
// module id = 801
// module chunks = 0